<mat-toolbar class="sidenav-header">
  <div class="menu-container">
    <button
      mat-icon-button
      class="pg-header-btn"
      mat-dialog-close
      (click)="close($event)"
      >
      <mat-icon>close</mat-icon>
    </button>
    <div class="pg-title">{{ dialogTitle }}</div>
    <span fxFlex></span>
  </div>
</mat-toolbar>

<mat-divider></mat-divider>
<form [formGroup]="formGroup" (ngSubmit)="createUpdateCompany()">
  <div class="form-field">
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.companyName" | translate }}</mat-label>
      <input formControlName="name" matInput />
      <mat-error>{{ "company.companyName" | translate }} {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.address" | translate }}</mat-label>
      <input formControlName="address" matInput />
      <mat-error>{{ "company.address" | translate }} {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.ssmID" | translate }}</mat-label>
      <input formControlName="ssmid" matInput />
      <mat-error>{{ "company.ssmID" | translate }} {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.paymentMethod" | translate }} </mat-label>
      <mat-select formControlName="isOnlinePayment">
        <mat-option [value]="true"> {{ "company.online" | translate }} </mat-option>
        <mat-option [value]="false"> {{ "company.offline" | translate }} </mat-option>
      </mat-select>
      <mat-error>{{ "company.paymentMethod" | translate }}  {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.parent" | translate }}</mat-label>
      <input formControlName="parentCompanyName" matInput />
      <mat-error>{{ "company.parent" | translate }} {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.bankName" | translate }}</mat-label>
      <mat-select formControlName="bankId">
        @for (x of bankSelectionList; track x) {
          <mat-option [value]="x.id">
            {{ x.name }}
          </mat-option>
        }
      </mat-select>
      <mat-error>{{ "company.bankName" | translate }} {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.bankAccNo" | translate }}</mat-label>
      <input formControlName="bankAccNo" matInput />
      <mat-error>{{ "company.bankAccNo" | translate }} {{ "error.required" | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
      <mat-label>{{ "company.accHolderName" | translate }}</mat-label>
      <input formControlName="accHolderName" matInput />
      <mat-error
        >{{ "company.accHolderName" | translate }} {{ "error.required" | translate }}</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%; padding-top: 4px;">
        <mat-label>{{ "company.vehicleTypeAccess" | translate }}</mat-label>
        <mat-select
          formControlName="vehicleTypeAccess"
          multiple
          >
          @for (x of (vehicleTypeAccessList) || []; track x) {
            <mat-option
              [value]="x"
              >
              {{ x }}
            </mat-option>
          }
        </mat-select>
        <mat-error
          >{{ "company.vehicleTypeAccess" | translate }}
          {{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          class="full-width mt-md"
          type="submit"
          [disabled]="formGroup.invalid"
          >
          {{ dialogBtn }}
        </button>
      </div>
    </form>
